import React from 'react';
import { styled } from 'baseui';
type PropsT = {
  hotkey: string;
};
export const IconContainer = styled<'div', {
  $selected?: boolean;
  $disabled?: boolean;
}>('div', ({
  $theme,
  $selected,
  $disabled
}) => ({
  borderRadius: '4px',
  backgroundColor: $selected ? $theme.colors.contentInverseSecondary : $theme.colors.backgroundPrimary,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '12px',
  width: '36px',
  height: '36px',
  pointerEvents: $disabled ? 'none' : 'auto',
  opacity: $disabled ? '0.3' : '1',
  ':hover': {
    cursor: $disabled ? 'not-allowed' : 'pointer',
    backgroundColor: $disabled ? 'none' : $theme.colors.backgroundTertiary
  },
  position: 'relative'
}));
const Container = styled('div', {
  backgroundColor: '#474444',
  color: 'white',
  width: 'auto',
  height: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  border: '1px solid white',
  padding: '2px 5px 2px 5px',
  fontSize: '10px',
  marginLeft: '5px',
  marginTop: '4px'
});
const Hotkey = ({
  hotkey
}: PropsT) => {
  const displayKey = hotkey.trim() === 'PLUS' ? '+' : hotkey;
  return <Container>{displayKey}</Container>;
};
export default Hotkey;